module.exports = __webpack_public_path__ + "static/media/SchoolCosDeliveryCentral.6b45e472.webp";